<template>
  <router-link
    class="mg-top-8px no-text-decoration"
    :to="'/settings/team/create?showModal=1'"
  >
    <NitButton :type="'accent'" class="t-12px">
      チームプランを2週間無料で試す
    </NitButton>
  </router-link>
</template>
